// extracted by css-extract-rspack-plugin
var _1 = "days-aFp3pm";
var _2 = "times-giF64b";
export { _1 as "days", _2 as "times" }
